module.exports = __webpack_public_path__ + "img/mci_logo_green_rectangle.0fe5abe9.png";